// DOM id for an annotatable thumbnail on the line/comment page.
//
// The same media can sit on a line and on a comment of that line at once, and
// the editor hands back only which image was tapped. An id built from the media
// alone would then appear twice on the page, and getElementById would always
// return the first (the line's) — so returning from annotating the comment's
// copy scrolled to the line's. Scoping the id by the line or comment that owns
// the thumbnail keeps each one unique. Build and look up ids only through this
// helper so the two sides cannot drift apart.
export const getMediaDomId = (ownerUuid, mediaId) => `pintura-media-${ownerUuid ?? "unknown"}-${mediaId}`;
